import Vue from 'vue';

export const kvUtils = {
  get: key => store.getters['keyValueState/get'](key),
  set: (key, value) => store.dispatch('keyValueState/setKeyValue', { key, value }, { root: true }),
};

Vue.prototype.$kvUtils = kvUtils;

export default {
  namespaced: true,
  state: {},
  mutations: {
    setKeyValue(state, { key, value }) {
      state[key] = value;
    },
  },
  actions: {
    setKeyValue({ commit }, data) {
      commit('setKeyValue', data);
    },
  },
  getters: {
    get: state => key => state[key],
  },
};
